<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
    class="template-popup"
    :closeBtn="follow && follow.guidCloseFlag === 'Y'"
    @close="closeAction"
  >
    <div class="content" 
         :style="`background-image: url(${follow.guidBackgroundUrl})`"
         data-sensors-exposure-event-name="Diversion_Exposure" 
         data-sensors-exposure-property-exposure_type="FOLLOW_POPUP"
         :data-sensors-exposure-property-exposure_code="follow.type"
         v-if="visible && follow"
    >
      <nd-button  
        data-sensors-exposure-event-name="Diversion_Exposure" 
        data-sensors-exposure-property-exposure_type="FOLLOW_POPUP_BTN" 
        @click="handleFollow" class="btn FOLLOW_POPUP_BTN"
        v-if="follow.guidButtonFlag === 'Y'"
      >
        {{follow.guidText || '一键关注公众号'}}</nd-button>
    </div>
  </nd-dialog>
</template>

<script>
import { copyToClipbord } from '@/assets/utils'
export default {
  name: 'followPopUp',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    follow: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    closeAction () {
      this.visible = false
    },
    handleFollow () {
      copyToClipbord(this.follow.code)
      this.$message(`${this.follow.type === 'CT' ? '崇天' : '天美贷'}公众号已复制，请微信关注`, 2000)
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.template-popup {
  /deep/.default-content {
    padding: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('./images/pop_zhuanxiang@2x.png') no-repeat center;
    background-size: 100% 100%;
    height: 520px;
    width: 620px;
    position: relative;
    padding-top: 350px;
  }
  .btn {
    width: 320px;
    height: 80px;
    line-height: 80px;
  }
}

</style>